var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: 1050,
        maskClosable: false,
        footer: null,
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "display-setting" }, [
        _c("div", { staticClass: "preview-wrap" }, [
          _c("div", { staticClass: "phone-shell" }, [
            _c("div", { staticClass: "phone-screen" }, [
              _c(
                "div",
                { staticClass: "mall-nav" },
                [
                  _c("a-icon", { attrs: { type: "left" } }),
                  _c("span", { staticClass: "mall-nav-title" }, [
                    _vm._v(_vm._s(_vm.materialName)),
                  ]),
                  _c("a-icon", { attrs: { type: "ellipsis" } }),
                ],
                1
              ),
              _c("div", { staticClass: "phone-body" }, [
                _c(
                  "div",
                  { staticClass: "goods-main-img" },
                  [
                    _vm.mainImgs.length
                      ? _c(
                          "a-carousel",
                          {
                            attrs: {
                              autoplay: "",
                              "dots-class-name": "slick-dots",
                            },
                          },
                          _vm._l(_vm.mainImgs, function (img, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "carousel-item" },
                              [_c("img", { attrs: { src: _vm.imgUrl(img) } })]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "img-placeholder" }, [
                          _vm._v("暂无主图"),
                          _c("br"),
                          _vm._v("请在右侧上传"),
                        ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "goods-info" }, [
                  _c("div", { staticClass: "goods-name" }, [
                    _vm._v(_vm._s(_vm.materialName)),
                  ]),
                  _c("div", { staticClass: "goods-price" }, [_vm._v("¥ --")]),
                ]),
                _c("div", { staticClass: "detail-title" }, [
                  _vm._v("—— 商品详情 ——"),
                ]),
                _c(
                  "div",
                  { staticClass: "goods-detail" },
                  [
                    _vm.detailImgs.length
                      ? _vm._l(_vm.detailImgs, function (img, i) {
                          return _c("img", {
                            key: i,
                            attrs: { src: _vm.imgUrl(img) },
                          })
                        })
                      : _c("div", { staticClass: "img-placeholder" }, [
                          _vm._v("暂无详情图"),
                          _c("br"),
                          _vm._v("请在右侧上传"),
                        ]),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "preview-tip" }, [_vm._v("手机端实时预览")]),
        ]),
        _c(
          "div",
          { staticClass: "form-wrap" },
          [
            _c(
              "a-form-item",
              {
                attrs: {
                  label: "商城上架",
                  labelCol: { span: 5 },
                  wrapperCol: { span: 18, offset: 1 },
                },
              },
              [
                _c("a-switch", {
                  attrs: { checked: _vm.onShelf === "1" },
                  on: { change: _vm.onShelfChange },
                }),
                _c("span", { staticClass: "shelf-tip" }, [
                  _vm._v(
                    _vm._s(
                      _vm.onShelf === "1"
                        ? "已上架，会员商城可见"
                        : "未上架，商城不显示"
                    )
                  ),
                ]),
              ],
              1
            ),
            _c(
              "a-form-item",
              {
                attrs: {
                  label: "主图",
                  labelCol: { span: 5 },
                  wrapperCol: { span: 18, offset: 1 },
                },
              },
              [
                _c("j-image-upload", {
                  attrs: {
                    bizPath: "material",
                    text: "上传主图",
                    isMultiple: "",
                  },
                  model: {
                    value: _vm.imgName,
                    callback: function ($$v) {
                      _vm.imgName = $$v
                    },
                    expression: "imgName",
                  },
                }),
                _c("div", { staticClass: "field-tip" }, [
                  _vm._v("商城列表与详情页顶部轮播，建议正方形，最多4张"),
                ]),
              ],
              1
            ),
            _c(
              "a-form-item",
              {
                attrs: {
                  label: "详情图",
                  labelCol: { span: 5 },
                  wrapperCol: { span: 18, offset: 1 },
                },
              },
              [
                _c("j-image-upload", {
                  attrs: {
                    bizPath: "material",
                    text: "上传详情图",
                    isMultiple: "",
                  },
                  model: {
                    value: _vm.imgDetail,
                    callback: function ($$v) {
                      _vm.imgDetail = $$v
                    },
                    expression: "imgDetail",
                  },
                }),
                _c("div", { staticClass: "field-tip" }, [
                  _vm._v("详情页长图，按上传顺序纵向排列"),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-footer" },
              [
                _c("a-button", { on: { click: _vm.handleClose } }, [
                  _vm._v("取消"),
                ]),
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-left": "8px" },
                    attrs: { type: "primary", loading: _vm.saving },
                    on: { click: _vm.handleSave },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }